import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

function CalendarViewModal({
  todayCurrent,
  timelineCurrent,
  weekCurrent,
  monthCurrent,
  lastAccessCurrent,
  savePrefrenceCallback,
  setHomeData,
}) {
  const { register, setValue, watch } = useFormContext();

  const [, setSelectedView] = useState("");

  const CalTimeline = watch("CalTimeline");
  const CalToday = watch("CalToday");
  const CalCurWeek = watch("CalCurWeek");
  const CalCurMo = watch("CalCurMo");
  const CalLastView = watch("CalLastView");

  useEffect(() => {
    if (timelineCurrent) {
      setValue("CalTimeline", true);
      setSelectedView("CalTimeline");
    }

    if (todayCurrent) {
      setValue("CalToday", true);
      setSelectedView("CalToday");
    }

    if (weekCurrent) {
      setValue("CalCurWeek", true);
      setSelectedView("CalCurWeek");
    }

    if (monthCurrent) {
      setValue("CalCurMo", true);
      setSelectedView("CalCurMo");
    }

    if (lastAccessCurrent) {
      setValue("CalLastView", true);
      setSelectedView("CalLastView");
    }
  }, [todayCurrent, timelineCurrent, weekCurrent, monthCurrent, lastAccessCurrent, setValue]);

  const handleViewChange = (field) => {
    setSelectedView(field);
    // Reset all values to false before setting the selected one to true
    setValue("CalTimeline", field === "CalTimeline");
    setValue("CalToday", field === "CalToday");
    setValue("CalCurWeek", field === "CalCurWeek");
    setValue("CalCurMo", field === "CalCurMo");
    setValue("CalLastView", field === "CalLastView");

    setTimeout(() => {
      const updatedValues = watch();
      savePrefrenceCallback(updatedValues);
      setHomeData(updatedValues);
    }, 0);
  };

  return (
    <>
      <div className="two-radio-groups">
        <div
          className="d-flex align-items-start justify-content-evenly"
          style={{ height: "max-content", gap: "0px", padding: "0px" }}
        >
          <div className="d-flex radio-buttons">
            <div className="radio-group" style={{ gap: "0px" }}>
              <div
                className={"d-flex align-items-center gap-1 height-35"}
                onClick={() => handleViewChange("CalTimeline")}
              >
                <input
                  type="radio"
                  value="CalTimeline"
                  {...register("CalTimeline")}
                  className="radio-input"
                />
                <div className={`radio-circle ${CalTimeline ? "checked" : ""}`} />
                <span>Timeline</span>
              </div>

              <div
                className={"d-flex align-items-center gap-1 height-35  "}
                onClick={() => handleViewChange("CalToday")}
              >
                <input
                  type="radio"
                  value="CalToday"
                  {...register("CalToday")}
                  className="radio-input"
                />
                <div className={`radio-circle ${CalToday ? "checked" : ""}`} />
                <span>Today</span>
              </div>

              <div
                className={"d-flex align-items-center gap-1 height-35  "}
                onClick={() => handleViewChange("CalCurWeek")}
              >
                <input
                  type="radio"
                  value="CalCurWeek"
                  {...register("CalCurWeek")}
                  className="radio-input"
                />
                <div className={`radio-circle ${CalCurWeek ? "checked" : ""}`} />
                <span>Current Week</span>
              </div>
            </div>
          </div>

          <div className="d-flex radio-buttons">
            <div className="radio-group" style={{ gap: "0px" }}>
              <div
                className={"d-flex align-items-center gap-1 height-35 "}
                onClick={() => handleViewChange("CalCurMo")}
              >
                <input
                  type="radio"
                  value="CalCurMo"
                  {...register("CalCurMo")}
                  className="radio-input"
                />
                <div className={`radio-circle ${CalCurMo ? "checked" : ""}`} />
                <span>Current Month</span>
              </div>

              <div
                className={"d-flex align-items-center gap-1 height-35"}
                onClick={() => handleViewChange("CalLastView")}
              >
                <input
                  type="radio"
                  value="CalLastView"
                  {...register("CalLastView")}
                  className="radio-input"
                />
                <div className={`radio-circle ${CalLastView ? "checked" : ""}`} />
                <span>Last Accessed View</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CalendarViewModal;
